import React, { createContext, useMemo } from 'react';
import {
  DEFAULT_LOCALE,
} from '@/lib/constants/locales';

type LocaleContextObject = {
  locale: string;
};

export const LocaleContext = createContext<LocaleContextObject>({
  locale: DEFAULT_LOCALE,
});

export default function LocaleProvider({ children }: React.PropsWithChildren) {
  const localeContextObject = useMemo(() => ({
    locale: DEFAULT_LOCALE,
  }), [DEFAULT_LOCALE]);

  return (
    <LocaleContext.Provider value={localeContextObject}>
      {children}
    </LocaleContext.Provider>
  );
}
